const ContactDetails = ({ data }) => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-purple-50 py-10 px-4">
      <div className="max-w-4xl mx-auto backdrop-blur-lg bg-white/90 rounded-3xl p-8">
        <h1 className="text-3xl font-bold text-deep-purple mb-8 border-b pb-3">
          Contact Info
        </h1>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
          <div>
            <p className="flex items-center gap-2 text-gray-500 text-sm mb-1">
              <i className="fa fa-user text-gray-400" /> Full Name
            </p>
            <p className="text-lg font-semibold text-deep-purple">{data.name}</p>
          </div>

          <div>
            <p className="flex items-center gap-2 text-gray-500 text-sm mb-1">
              <i className="fa fa-envelope text-gray-400" /> Email Address
            </p>
            <p className="text-lg font-medium text-deep-purple">{data.email}</p>
          </div>

          <div>
            <p className="text-gray-500 text-sm mb-1">Status</p>
            <span
              className={`inline-flex items-center gap-2 text-sm font-semibold px-3 py-1 rounded-full ${
                data.status === "active"
                  ? "bg-primary/10 text-green-700"
                  : "bg-red-100 text-red-700"
              }`}
            >
              <i
                className={`fa ${
                  data.status === "active"
                    ? "fa-check-circle"
                    : "fa-times-circle"
                }`}
              />
              {data.status}
            </span>
          </div>

          <div>
            <p className="text-gray-500 text-sm mb-1">Message Type</p>
            <span className="inline-block text-sm font-semibold px-3 py-1 rounded-full bg-indigo-100 text-deep-purple capitalize">
              {data.type}
            </span>
          </div>

          <div className="sm:col-span-2">
            <p className="text-gray-500 text-sm mb-1">Event Title</p>
            <p className="text-lg font-semibold text-gray-700">
              {data.eventData?.title?.en}
            </p>
          </div>

          <div className="sm:col-span-2">
            <p className="text-gray-500 text-sm mb-1">User Reason</p>
            <p className="text-gray-700 text-base">{data.reason}</p>
          </div>

          <div className="sm:col-span-2">
            <p className="flex items-center gap-2 text-gray-500 text-sm mb-1">
              Admin Comment
            </p>
            <div className="mt-1 bg-gray-50 border border-gray-200 rounded-lg p-4 text-gray-700 text-sm leading-relaxed">
              {data.comment}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactDetails;
